import React, { forwardRef } from "react";
import "../styles/input.css";

const Input = forwardRef(({ ...props }, ref) => {
  return (
      <>
      <label htmlFor={props.id} className="label">
        {props.label}
      </label>
      <input ref={ref} {...props} className={`${props.className}`}/>
      </>
  );
});

export default Input;
